import { Button, Typography } from "antd"
import React from "react"

import { empty } from "../../../constants/placeholders"
import { ROW_OPEN_ATTRIBUTE } from "../helpers/invoice-row-click.ts"

type Translate = (key: string, options?: Record<string, unknown>) => string

interface InvoiceNumberCellProps {
  number: string | null | undefined
  t: Translate
}

/**
 * The invoice ID opens the invoice. It carries no handler of its own: the
 * click reaches the row, which decides between editing it and viewing it.
 */
export function InvoiceNumberCell({ number, t }: InvoiceNumberCellProps) {
  if (!number) return <Typography.Text strong>{empty}</Typography.Text>

  return (
    <Button
      type="link"
      className="h-auto p-0 font-semibold"
      aria-label={t("invoices.view.open", { number })}
      {...{ [ROW_OPEN_ATTRIBUTE]: "" }}
    >
      {number}
    </Button>
  )
}
